import React from 'react'
import './slider1.css'

const Slider1 = () => {
  return (
    <>
      <div className="main">
        <div className="slider">
          <figure>
            <img src="./img/banner1.png" />
            <img src="./img/banner2.png" />
            <img src="./img/banner1.png" />
            <img src="./img/banner4.png" />
            <img src="./img/banner2.png" />
          </figure>
        </div>
      </div>

    </>
  )
}

export default Slider1